import { Center, Flex } from "@chakra-ui/react";
import { ReactComponent as Logo } from "media/logo.svg";
import { useHistory } from "react-router-dom";
import BgTutoria from "media/bgTutoria.png";

export default function ContainerAuth({ children }) {
  const history = useHistory();
  return (
    <Center height="100vh" width="100vw" overflow="auto" bgImage={BgTutoria}>
      <Flex
        bg="white"
        p={12}
        direction="column"
        alignItems="center"
        minWidth={400}
        maxWidth={500}
        gap={4}
      >
        <Flex mb={8} onClick={() => history.push("/")} cursor="pointer">
          <Logo />
        </Flex>
        {children}
      </Flex>
    </Center>
  );
}
